"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.initExplorer = exports.ExplorerToggle = void 0;
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var react_redux_1 = require("react-redux");
var redux_1 = require("redux");
var redux_thunk_1 = __importDefault(require("redux-thunk"));
// import { perfMiddleware } from '../../utils/performance';
var Explorer_1 = __importDefault(require("./Explorer"));
var ExplorerToggle_1 = __importDefault(require("./ExplorerToggle"));
exports.ExplorerToggle = ExplorerToggle_1["default"];
var explorer_1 = __importDefault(require("./reducers/explorer"));
var nodes_1 = __importDefault(require("./reducers/nodes"));
/**
 * Initialises the explorer component on the given nodes.
 */
var initExplorer = function (explorerNode, toggleNode) {
    var rootReducer = redux_1.combineReducers({
        explorer: explorer_1["default"],
        nodes: nodes_1["default"],
    });
    var middleware = [
        redux_thunk_1["default"],
    ];
    // Uncomment this to use performance measurements.
    // if (process.env.NODE_ENV !== 'production') {
    //   middleware.push(perfMiddleware);
    // }
    var store = redux_1.createStore(rootReducer, {}, redux_1.compose(redux_1.applyMiddleware.apply(void 0, middleware), 
    // Expose store to Redux DevTools extension.
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : function (func) { return func; }));
    var startPage = parseInt(toggleNode.getAttribute('data-explorer-start-page'), 10);
    react_dom_1["default"].render((react_1["default"].createElement(react_redux_1.Provider, { store: store },
        react_1["default"].createElement(ExplorerToggle_1["default"], { startPage: startPage }, toggleNode.textContent))), toggleNode.parentNode);
    react_dom_1["default"].render((react_1["default"].createElement(react_redux_1.Provider, { store: store },
        react_1["default"].createElement(Explorer_1["default"], null))), explorerNode);
};
exports.initExplorer = initExplorer;
exports["default"] = Explorer_1["default"];
